<!-- Router outlet for child routes (review-tabs) -->
<router-outlet></router-outlet>

<!-- Main Clause Library content - only show when not on child route -->
@if (!isChildRouteActive()) {
<div class="h-full flex flex-col w-full gap-2 p-2">
    <!-- Header with tabs and actions -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 w-full">
        <!-- Tabs and Actions Row -->
        <div class="flex items-center justify-between w-full">
            <!-- Tabs -->
            <p-tabs [value]="activeTab" (valueChange)="onTabValueChange($event)"
                class="clause-library-tabs custom-tabview w-full border-b border-gray-200">
                <p-tablist>
                    <p-tab [value]="LIBRARY_TAB.CLAUSE" class="flex items-center !gap-2">
                        <div class="flex items-center gap-2">
                            <span class="text-gray-500 font-sans text-sm whitespace-nowrap">{{ 'Clause' | textCase
                                }}</span>
                        </div>
                    </p-tab>
                    <p-tab [value]="LIBRARY_TAB.CLAUSE_BUNDLE" class="flex items-center !gap-2">
                        <div class="flex items-center gap-2">
                            <span class="text-gray-500 font-sans text-sm whitespace-nowrap">{{ 'Clause bundle' |
                                textCase }}</span>
                        </div>
                    </p-tab>
                </p-tablist>
            </p-tabs>

            <!-- History and Review Clauses Buttons -->
            <div class="flex items-center gap-2">
                <app-button [label]="'History' | textCase" variant="outlined" icon="pi pi-history" severity="contrast"
                    (clicked)="getUploadedFilesAudit(true)" />
                <app-button [label]="'Review clauses' | textCase" variant="outlined" icon="pi pi-check-circle"
                    severity="contrast" (clicked)="openReviewClauses()" />

                <!-- Mobile menu -->
                <app-popover #mobileMenu [width]="'auto'" [maxHeight]="'50vh'" [showScrollbar]="true" class="md:hidden">
                    <ng-template #trigger>
                        <app-button icon="pi pi-ellipsis-v" variant="outlined" severity="contrast" />
                    </ng-template>
                    <ng-template #body>
                        <div class="flex flex-col gap-1 min-w-12.5rem">
                            <div class="flex flex-row items-center p-2 cursor-pointer hover:bg-gray-100 rounded"
                                (click)="getUploadedFilesAudit(true); mobileMenu.hide()">
                                <span class="pi pi-history"></span>
                                <span class="ml-2">{{ 'History' | textCase }}</span>
                            </div>
                            <div class="flex flex-row items-center p-2 cursor-pointer hover:bg-gray-100 rounded"
                                (click)="openReviewClauses(); mobileMenu.hide()">
                                <span class="pi pi-check-circle"></span>
                                <span class="ml-2">{{ 'Review clauses' | textCase }}</span>
                            </div>
                        </div>
                    </ng-template>
                </app-popover>
            </div>
        </div>
    </div>

    <!-- Content based on active tab -->
    @if (activeTab === LIBRARY_TAB.CLAUSE) {
    <!-- Clause Tab Content -->
    <div class="flex flex-col h-full">
        <!-- Search and Actions Row -->
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 w-full mb-2">
            <!-- Left side: Add button and search -->
            <div class="flex items-center gap-2 w-full md:w-auto">
                <app-button [label]="'Add clause' | textCase" variant="filled" severity="primary" icon="pi pi-plus"
                    (clicked)="addClause()" />
                <div class="flex-1 md:w-80">
                    <app-search-bar [placeholder]="'Search by clause name or clause text' | textCase"
                        [(ngModel)]="searchValue" (searchChange)="onSearch()" width="100%">
                    </app-search-bar>
                </div>
            </div>

            <!-- Right side: Sort and Filter buttons -->
            <div class="flex items-center gap-2">
                <app-popover #sortFilterPopover width="12rem">
                    <ng-template #trigger>
                        <app-button icon="pi pi-sort-alt" variant="outlined" severity="contrast" />
                    </ng-template>
                    <ng-template #body>
                        <div class="flex flex-col text-sm text-gray-800">
                            <app-button label="Name" variant="ghost" severity="contrast"
                                [class]="clauseSortBy === ClauseSortBy.Name ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                [icon]="clauseSortBy === ClauseSortBy.Name ? 'pi pi-check text-orange-500 text-xs' : ''"
                                iconPosition="right" (clicked)="setClauseSort(ClauseSortBy.Name)" />
                            <app-button label="Created date" variant="ghost" severity="contrast"
                                [class]="clauseSortBy === ClauseSortBy.CreatedAt ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                [icon]="clauseSortBy === ClauseSortBy.CreatedAt ? 'pi pi-check text-orange-500 text-xs' : ''"
                                iconPosition="right" (clicked)="setClauseSort(ClauseSortBy.CreatedAt)" />
                            <app-button label="Usage count" variant="ghost" severity="contrast"
                                [class]="clauseSortBy === ClauseSortBy.UsageCount ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                [icon]="clauseSortBy === ClauseSortBy.UsageCount ? 'pi pi-check text-orange-500 text-xs' : ''"
                                iconPosition="right" (clicked)="setClauseSort(ClauseSortBy.UsageCount)" />
                        </div>
                        <hr class="my-2" />
                        <div class="flex flex-col text-sm text-gray-800">
                            <app-button label="Ascending" variant="ghost" severity="contrast"
                                [class]="clauseSortOrder === 1 ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                [icon]="clauseSortOrder === 1 ? 'pi pi-arrow-down text-orange-500 text-xs' : 'pi pi-arrow-down text-black text-xs'"
                                iconPosition="right" (clicked)="setSortOrder(1)" />
                            <app-button label="Descending" variant="ghost" severity="contrast"
                                [class]="clauseSortOrder === -1 ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                [icon]="clauseSortOrder === -1 ? 'pi pi-arrow-up text-orange-500 text-xs' : 'pi pi-arrow-up text-black text-xs'"
                                iconPosition="right" (clicked)="setSortOrder(-1)" />
                        </div>
                    </ng-template>
                </app-popover>

                <app-button [label]="'Filter' | textCase" variant="outlined" severity="contrast" icon="pi pi-filter"
                    (clicked)="openFilterDialog()" />
            </div>
        </div>

        <!-- Action Bar (shown when items are selected) -->
        <div class="action-bar mb-2" *ngIf="selectedClauseIds.length > 0">
            <div class="action-bar-content">
                <p class="text-sm font-medium">
                    {{ selectedClauseIds.length }} item(s) selected
                </p>
                <div class="action-bar-divider"></div>
                <app-button [label]="'Edit' | textCase" variant="outlined" icon="pi pi-pencil"
                    (clicked)="openBulkEdit()" severity="contrast" />
                <app-button [label]="'Link to clause bundle' | textCase" variant="outlined" icon="pi pi-link"
                    (clicked)="openBulkLinkBundleDialog()" severity="contrast" />
                <app-button [label]="'Download' | textCase" variant="outlined" icon="pi pi-download"
                    (clicked)="bulkDownloadClauses()" severity="contrast" />
                <div class="action-bar-actions-right">
                    <app-button [label]="'Delete' | textCase" variant="outlined" icon="pi pi-trash"
                        (clicked)="bulkDeleteClauses()" severity="danger" />
                </div>
            </div>
        </div>

        <!-- Data Table -->
        <div [style.height]="selectedClauseIds.length > 0 ? 'calc(100vh - 16rem)' : 'calc(100vh - 12rem)'">
            <app-data-table #dataTable [data]="clausesData" [columns]="clauseTableColumns" [config]="clauseTableConfig"
                [dataKey]="'_id'" tableClass="flex-1" [customTemplates]="templatesMap" [externalPagination]="true"
                [externalFirst]="skip" [externalTotalRecords]="totalRecords"
                (selectionChange)="onSelectionChange($event)" (rowClick)="viewClauseDetails($event)"
                (pageChange)="onPageChange($event)" tableClass="h-full">
            </app-data-table>
        </div>
    </div>
    } @else {
    <!-- Clause Bundle Tab Content -->
    <div class="flex-1 min-h-0 flex flex-col">
        <app-clause-bundle class="flex-1 min-h-0 block" />
    </div>
    }
</div>
}

<!-- Data Table Templates -->
<ng-template #clauseBundleTemplateRef let-clause="$implicit">
    <span class="text-sm block truncate max-w-[200px]" [title]="getClauseBundleName(clause)">{{
        getClauseBundleName(clause) }}</span>
</ng-template>

<ng-template #sourceTemplateRef let-clause="$implicit">
    <span class="text-sm">{{ getSourceLabel(clause.source) }}</span>
</ng-template>


<ng-template #createdByTemplateRef let-clause="$implicit">
    <div class="flex items-center gap-2">
        <img [src]="clause.createdBy | userAvatar" alt="User Avatar" class="w-6 h-6 rounded-full" />
        <app-user-name-display [user]="clause.createdBy" />
    </div>
</ng-template>

<ng-template #createdAtTemplateRef let-clause="$implicit">
    <div class="flex items-center gap-1">
        <i class="pi pi-calendar text-gray-400 text-xs"></i>
        <span class="text-sm">{{ formatDate(clause.createdAt) }}</span>
    </div>
</ng-template>

<ng-template #actionsTemplateRef let-clause="$implicit">
    <div (click)="$event.stopPropagation()">
        <app-menu #menu [items]="getClauseMenuOptions(clause)">
            <i class="pi pi-ellipsis-v icon-sm p-0 m-0 cursor-pointer p-2 hover:bg-gray-100 rounded-full transition-colors"
                (click)="menu.toggle($event)"></i>
        </app-menu>
    </div>
</ng-template>

<!-- Add Clause (method selection + manual draft) Dialog -->
<app-dialog [(visible)]="showAddClauseDialog" (closed)="closeAddClauseDialog()" class="w-[576px] clause-library-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Add clause' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
    <div class="flex flex-col gap-4 px-1">
        <!-- Clause bundle (both steps) -->
        <div class="flex flex-col sm:flex-row gap-2 items-stretch sm:items-end">
            <div class="flex-1">
                <p class="text-sm mb-2">{{ 'Clause bundle' | textCase }}</p>
                <app-multi-select [options]="clauseBundleOptions" [(value)]="addClauseSelectedBundleIds"
                    [config]="{placeholder: 'Select', styleClass: 'w-full'}">
                </app-multi-select>
            </div>
            <app-button [label]="'Add' | textCase" variant="outlined" severity="contrast"
                (clicked)="addClauseNewBundle()" class="h-[2.5rem]" />
        </div>

        @if(showMethodSelectionView) {
        <p class="text-sm mt-2">How would you like to create clause?</p>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div class="gradient-card flex flex-col gap-2 p-4 rounded-xl border text-left transition-all min-h-[7rem] cursor-pointer"
                (click)="selectAddClauseMethod(AddClauseMethod.MANUAL_DRAFT)"
                [class.theme-text-border]="selectedAddClauseMethod === AddClauseMethod.MANUAL_DRAFT"
                [class.border-gray-200]="selectedAddClauseMethod !== AddClauseMethod.MANUAL_DRAFT">
                <app-icon [type]="CLAUSE_LIBRARY_ICONS.MANUAL_DRAFT" [source]="ICON_SOURCE.SVG" [size]="'default'"
                    class="self-start"></app-icon>
                <span class="text-sm font-semibold text-gray-900">{{ 'Manual draft' | textCase }}</span>
                <span class="text-sm text-gray-600">Add a new clause manually or let AI draft one instantly for
                    you.</span>
            </div>
            <div class="gradient-card flex flex-col gap-2 p-4 rounded-xl border text-left transition-all min-h-[7rem] cursor-pointer"
                (click)="selectAddClauseMethod(AddClauseMethod.UPLOAD_CONTRACT)"
                [class.theme-text-border]="selectedAddClauseMethod === AddClauseMethod.UPLOAD_CONTRACT"
                [class.border-gray-200]="selectedAddClauseMethod !== AddClauseMethod.UPLOAD_CONTRACT">
                <app-icon [type]="CLAUSE_LIBRARY_ICONS.UPLOAD_CONTRACT" [source]="ICON_SOURCE.SVG" [size]="'default'"
                    class="self-start"></app-icon>
                <span class="text-sm font-semibold text-gray-900">{{ 'Upload contract' | textCase }}</span>
                <span class="text-sm text-gray-600">Upload your contract, and we'll automatically extract all its
                    clauses for you.</span>
            </div>
            <div class="gradient-card flex flex-col gap-2 p-4 rounded-xl border text-left transition-all min-h-[7rem] cursor-pointer"
                (click)="selectAddClauseMethod(AddClauseMethod.EXCEL_IMPORT)"
                [class.theme-text-border]="selectedAddClauseMethod === AddClauseMethod.EXCEL_IMPORT"
                [class.border-gray-200]="selectedAddClauseMethod !== AddClauseMethod.EXCEL_IMPORT">
                <app-icon [type]="CLAUSE_LIBRARY_ICONS.EXCEL_IMPORT" [source]="ICON_SOURCE.SVG" [size]="'default'"
                    class="self-start"></app-icon>
                <span class="text-sm font-semibold text-gray-900">{{ 'Excel import' | textCase }}</span>
                <span class="text-sm text-gray-600">Import an Excel file to automatically fill in clauses.</span>
            </div>
            <div class="bg-gray-200 border border-gray-200 flex flex-col gap-2 p-4 rounded-xl text-left transition-all min-h-[7rem] cursor-not-allowed relative"
                (click)="selectAddClauseMethod(AddClauseMethod.INTEGRATIONS)">
                <app-icon [type]="CLAUSE_LIBRARY_ICONS.INTEGRATIONS" [source]="ICON_SOURCE.SVG" [size]="'default'"
                    class="self-start"></app-icon>
                <span class="text-sm font-semibold text-gray-900">{{ 'Integrations' | textCase }}</span>
                <span class="text-sm text-gray-600">Connect... automatically extract clauses for you.</span>
                <div class="absolute inset-0 bg-white/80 z-30 flex items-center justify-center h-full w-full"
                    pTooltip="Sync clause directly from your connected CLM system. Coming soon" tooltipPosition="top">
                    <span class="text-sm rounded-base px-2 py-1 theme-text-border">
                        <span class="theme-text">Coming soon!</span>
                    </span>
                </div>
            </div>
        </div>
        }
    </div>
    </ng-template>
    <ng-template #footerTemplate>
        @if(showMethodSelectionView) {
        <div class="flex justify-end w-full">
            <app-button [label]="'Continue' | textCase" variant="filled" severity="primary"
                (clicked)="continueAddClause()" [disabled]="isAddClauseContinueDisabled()" />
        </div>
        }
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showAddBundleDialog" (closed)="closeAddBundleDialog()"
    class="w-[90vw] max-w-[500px] clause-library-dialog add-bundle-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Add clause bundle' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
        <form [formGroup]="addBundleForm">
            <div class="flex flex-col gap-1 mb-3">
                <label for="addBundleName" class="text-sm sm:text-base">Name <span class="text-danger">*</span></label>
                <input id="addBundleName" formControlName="name" placeholder="Enter bundle name"
                    class="w-full border outline-none rounded-base p-2 text-sm sm:text-base" />
                @if (addBundleFormControls.name.invalid && (addBundleFormControls.name.dirty ||
                addBundleFormControls.name.touched)) {
                <span class="text-danger text-xs">Name is required.</span>
                }
            </div>
        </form>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Add" variant="filled" severity="primary" (clicked)="createBundleAndSelect()"
                [disabled]="addBundleForm.invalid" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showPromptForClauseDialog" (closed)="closePromptForClauseDialog()"
    class="max-w-[28rem] clause-library-dialog">
    <ng-template #bodyTemplate>
        <div class="flex flex-col w-full bg-white rounded-lg">
            <div class="flex items-center justify-between px-4 pt-4 pb-2">
                <span class="text-base font-bold text-gray-800">{{ 'Prompt for clause text' | textCase }}</span>
                <app-button icon="pi pi-times" variant="ghost" severity="contrast"
                    (clicked)="closePromptForClauseDialog()" />
            </div>
            <div class="px-4 pb-4">
                <textarea [(ngModel)]="promptForClauseText" placeholder="Type here"
                    class="w-full min-h-[8rem] p-3 border border-gray-300 rounded-lg text-sm outline-none resize-none placeholder:text-gray-400 focus:border-orange-500"></textarea>
                <div class="flex justify-end mt-3">
                    <app-button label="Submit" variant="filled" severity="primary" (clicked)="submitPromptForClause()"
                        [loading]="isPromptForBulkEditMode ? bulkEditGenerateLoading : generateClauseTextLoading" />
                </div>
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- Excel import: Upload document dialog -->
<app-dialog [(visible)]="showExcelUploadDialog" (closed)="closeExcelUploadDialog()"
    class="w-[60rem] h-[35rem] clause-library-dialog">
    <ng-template #headerTemplate>
        <div class="font-bold text-lg text-black">{{ 'Upload document' | textCase }}</div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 px-1">
            <div class="flex flex-col sm:flex-row gap-2 items-stretch sm:items-end">
                <div class="flex-1">
                    <p class="text-sm mb-2">{{ 'Clause bundle' | textCase }}</p>
                    <app-multi-select [options]="clauseBundleOptions" [(value)]="excelUploadSelectedBundleIds"
                        [config]="{ placeholder: 'Bundle name', styleClass: 'w-full' }">
                    </app-multi-select>
                </div>
                <app-button label="Add" variant="outlined" severity="contrast" (clicked)="addClauseNewBundle()"
                    class="h-[2.5rem]" />
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 h-[20rem]">
                <div class="file-upload-wrapper flex flex-col gap-4">
                    <p class="text-sm text-black">
                        Download the sample sheet from
                        <a class="underline underline-offset-4 text-orange-500 cursor-pointer"
                            (click)="downloadClauseSampleExcel()">here</a>
                    </p>
                    <app-file-drop [fileTypes]="EXCEL_UPLOAD_ALLOWED_TYPES" [maxFileSize]="EXCEL_UPLOAD_MAX_SIZE_MB"
                        [multiple]="true" [existingFiles]="getExcelUploadExistingFiles()"
                        (uploadData)="onExcelFileUpload($event)" (removeFile)="onExcelFileRemove($event)">
                    </app-file-drop>
                    <p class="text-sm text-gray-700">Note: Uploaded files will be added to this knowledge base and
                        will be stored in files.</p>
                </div>
                <div class="flex flex-col border border-gray-200 rounded-lg p-3">
                    <p class="text-sm mb-2">Selected files</p>
                    <div class="flex-1 overflow-y-auto space-y-2">
                        @if(excelUploadFiles.length === 0) {
                        <div class="flex min-h-full items-center justify-center">
                            <p class="text-sm text-gray-500">No files selected</p>
                        </div>
                        } @else {
                        @for (item of excelUploadFiles; track item.file.name + item.file.size) {
                        <div
                            class="flex items-center justify-between gap-2 p-2 rounded-lg border border-gray-100 bg-gray-50">
                            <div class="flex items-center gap-2 min-w-0 flex-1">
                                <div
                                    class="w-8 h-8 flex-shrink-0 rounded bg-green-100 flex items-center justify-center">
                                    <i class="pi pi-file text-green-600 text-sm"></i>
                                </div>
                                <div class="min-w-0">
                                    <span class="text-sm font-medium text-gray-800 truncate block">{{ item.file.name
                                        }}</span>
                                    <span class="text-xs text-gray-500">{{ formatExcelFileSize(item.file.size) }}</span>
                                </div>
                            </div>
                            <div class="flex items-center gap-2 flex-shrink-0">
                                <app-button [label]="'Remove' | textCase" variant="outlined" severity="danger"
                                    (clicked)="removeExcelUploadFile(item)" />
                            </div>
                        </div>
                        }
                        }
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Upload" variant="filled" severity="primary" (clicked)="submitExcelUpload()"
                [disabled]="excelUploadFiles.length === 0 || excelUploadSubmitting" [loading]="excelUploadSubmitting" />
        </div>
    </ng-template>
</app-dialog>

<!-- View/Edit Clause Dialog (also used for Add manual). Disable close when loading to prevent accidental close during generation. -->
@if((currentClause && (currentClause._id ?? currentClause.name)) || isAddMode) {
<app-dialog [visible]="viewEditDialog" (closed)="onViewEditDialogVisibleChange(false)"
    [closable]="!(generateClauseTextLoading || rephraseClauseLoading)"
    [showCloseButton]="!(generateClauseTextLoading || rephraseClauseLoading)"
    class="w-[40rem] clause-library-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ (isAddMode ? 'Add clause' : (isEditMode ? 'Edit clause' : 'Clause details')) | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2" [class.opacity-50]="!isEditMode && !isAddMode">
            <div>
                <p class="text-sm mb-2">{{ 'Clause bundle' | textCase }}</p>
                <app-multi-select [options]="clauseBundleOptions" [(value)]="currentClauseBundleIds"
                    [config]="{placeholder: 'Select clause bundles', styleClass: 'w-full', appendTo: 'body', disabled: !isEditMode && !isAddMode}">
                </app-multi-select>
            </div>
            @if(!isEditMode && !isAddMode) {
            <div class="flex flex-col gap-2">
                <div class="flex flex-col gap-1">
                    <p class="text-sm">Source</p>
                    <div class="p-2 border border-gray-300 rounded-lg">
                        <span class="text-sm">{{ getSourceLabel(currentClause.source!) }}</span>
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div class="flex flex-col gap-1">
                        <p class="text-sm">{{ 'Created by' | textCase }}</p>
                        <div class="p-2 border border-gray-300 rounded-lg">
                            <app-user-name-display [user]="currentClause.createdBy" />
                        </div>
                    </div>
                    <div class="flex flex-col gap-1">
                        <p class="text-sm">{{ 'Created date' | textCase }}</p>
                        <div class="p-2 border border-gray-300 rounded-lg">
                            <span class="text-sm">{{ formatDate(currentClause.createdAt) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
        <div class="flex flex-col gap-2">
            <p class="text-sm">{{ 'Clause name' | textCase }} @if(isEditMode || isAddMode) {<span class="text-red-500">
                    *</span>}
            </p>
            @if(!isEditMode && !isAddMode) {
            <p class="text-base">{{ currentClause.name }}</p>
            } @else {
            <input type="text" placeholder="Type here"
                class="w-full p-3 border border-gray-300 rounded-lg text-sm outline-none placeholder:text-gray-400 focus:border-orange-500"
                [(ngModel)]="currentClause.name" />
            }
        </div>
        <div class="flex flex-col" [class.gap-2]="isEditMode">
            <div class="flex items-center justify-between">
                <div class="flex items-baseline gap-1">
                    <p class="text-sm mb-2">{{ 'Clause text' | textCase }}
                        @if(isEditMode || isAddMode) {
                        <span class="text-red-500">*</span>
                        }
                    </p>
                    @if (isClauseTextExpanded) {
                    <app-button [icon]="'minimize-2'" variant="ghost" severity="contrast"
                        [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                        (clicked)="toggleClauseTextExpanded()" />
                    } @else {
                    <app-button [icon]="'maximize-2'" variant="ghost" severity="contrast"
                        [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                        (clicked)="toggleClauseTextExpanded()" />
                    }
                </div>
                @if(isEditMode || isAddMode) {
                <div class="flex items-center gap-2">
                    <app-button [icon]="CLAUSE_LIBRARY_ICONS.GENERATE_CLAUSE_TEXT" [iconSource]="ICON_SOURCE.SVG"
                        [size]="'default'" variant="outlined" severity="contrast"
                        [pTooltip]="'Generate clause text' | textCase" tooltipPosition="top"
                        (clicked)="openPromptForClauseDialog()" [loading]="generateClauseTextLoading" />
                    <app-button [icon]="CLAUSE_LIBRARY_ICONS.REPHRASE_CLAUSE_TEXT" [iconSource]="ICON_SOURCE.SVG"
                        [size]="'default'" variant="outlined" severity="contrast"
                        [pTooltip]="'Rephrase clause text' | textCase" tooltipPosition="top"
                        (clicked)="rephraseClauseForEdit()" [disabled]="!(currentClause.text ?? '').trim()"
                        [loading]="rephraseClauseLoading" />
                </div>
                }
            </div>
            <div class="relative border border-gray-300 rounded-lg overflow-hidden bg-white"
                [style.height]="isClauseTextExpanded ? '18rem' : '7rem'">
                @if((isEditMode || isAddMode) && (generateClauseTextLoading || rephraseClauseLoading)) {
                <div class="absolute inset-0 flex items-start justify-start gap-2 p-3 bg-white/80 z-10 rounded-lg">
                    <app-blob-loader [width]="'1.5rem'" [height]="'1.5rem'"></app-blob-loader>
                    <div class="text-sm italic theme-text">
                        Constructing<span>{{ dots$ | async }}</span>
                    </div>
                </div>
                }
                @if(!isEditMode && !isAddMode) {
                <div class="w-full h-full p-3 text-sm overflow-y-auto whitespace-pre-wrap">{{
                    currentClause.text}}</div>
                } @else {
                <textarea placeholder="Type here"
                    class="w-full h-full p-3 text-sm outline-none resize-none overflow-y-auto placeholder:text-gray-400 focus:border-orange-500 border-0 box-border"
                    [(ngModel)]="currentClause.text"></textarea>
                }
            </div>
        </div>
    </div>
    </ng-template>
    <ng-template #footerTemplate>
        @if(isEditMode || isAddMode) {
        <div class="flex justify-end gap-2">
            <app-button label="Save" variant="filled" (clicked)="saveClause()" [enableThrottle]="true"
                severity="primary"
                [disabled]="!currentClause.name?.trim() || saveClauseLoading || generateClauseTextLoading || rephraseClauseLoading"
                [loading]="saveClauseLoading" />
        </div>
        }
    </ng-template>
</app-dialog>
}

<!-- Link to Clause Bundle Dialog (single and bulk use same dialog) -->
<app-dialog [(visible)]="showLinkBundleDialog" class="w-[50rem] clause-library-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Link to clause bundles' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
    <div class="flex flex-col gap-4 min-h-[20rem]">
        <p class="text-sm text-black">You are linking {{ selectedClauseIds.length }} selected clauses. Choose clause
            bundles below to complete the linking</p>

        <!-- Search bar with Create new button -->
        <div class="flex items-center justify-between gap-3">
            <div class="flex-1 relative">
                <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-orange-500 text-sm"></i>
                <input type="text" [(ngModel)]="bulkLinkSearchValue" placeholder="Search with name"
                    class="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-sm outline-none placeholder:text-gray-400 focus:border-orange-500" />
            </div>
            <app-button label="Create new" variant="outlined" severity="contrast"
                (clicked)="createNewBundleFromBulkLink()" />
        </div>

        <!-- Clause bundles grid with checkboxes -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-full overflow-y-auto">
            @for(bundle of filteredClauseBundles; track bundle._id) {
            <div class="flex items-center gap-3 p-4 border rounded-xl cursor-pointer transition-all hover:bg-gray-50  border-gray-200"
                (click)="toggleBundleSelection(bundle._id)">
                <div class="flex items-center shrink-0" (click)="$event.stopPropagation()">
                    <app-checkbox [config]="{ binary: true, size: 'small'}" [value]="isBundleSelected(bundle._id)"
                        (onChange)="toggleBundleSelection(bundle._id)">
                    </app-checkbox>
                </div>
                <div class="flex-1 min-w-0 flex items-center">
                    <p class="text-sm font-semibold text-gray-900 truncate">{{ bundle.name }}</p>
                </div>
            </div>
            }
            @if(filteredClauseBundles.length === 0) {
            <div class="col-span-2 flex min-h-[12rem] items-center justify-center py-8 text-sm text-gray-500">
                {{ 'No clause bundles found' | textCase }}
            </div>
            }
        </div>
    </div>
    </ng-template>
    <ng-template #footerTemplate>
        <span class="flex gap-2">
            <app-button label="Submit" variant="filled" (clicked)="submitBulkLinkToBundles()" [enableThrottle]="true"
                severity="primary" [disabled]="selectedBundleIdsForBulkLink.length === 0 || bulkLinkingToBundles"
                [loading]="bulkLinkingToBundles" />
        </span>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showCreateBundleInBulkLinkDialog" (closed)="closeCreateBundleInBulkLinkDialog()"
    class="max-w-[28rem] clause-library-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Create clause bundle' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
        <form [formGroup]="createBundleFromBulkLinkForm">
            <div class="flex flex-col gap-1 mb-3">
                <label for="createBundleFromBulkLinkName" class="text-sm sm:text-base">Name <span
                        class="text-danger">*</span></label>
                <input id="createBundleFromBulkLinkName" formControlName="name"
                    placeholder="Enter bundle name"
                    class="w-full border outline-none rounded-base p-2 text-sm sm:text-base" />
                @if (createBundleFromBulkLinkFormControls.name.invalid &&
                (createBundleFromBulkLinkFormControls.name.dirty ||
                createBundleFromBulkLinkFormControls.name.touched)) {
                <span class="text-danger text-xs">Name is required.</span>
                }
            </div>
        </form>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Create" variant="filled" severity="primary" (clicked)="submitCreateBundleFromBulkLink()"
                [disabled]="createBundleFromBulkLinkForm.invalid" [loading]="createBundleFromBulkLinkLoading" />
        </div>
    </ng-template>
</app-dialog>

<!-- Filter Drawer -->
@if(filterDialog) {
<p-drawer [(visible)]="filterDialog" position="right" styleClass="clause-library-filter-drawer">
    <ng-template pTemplate="headless">
        <div class="flex items-center justify-between p-4 flex-shrink-0 border-b">
            <span class="text-lg font-semibold">{{ 'Filter' | textCase }}</span>
            <div class="flex gap-2 items-center">
                <i class="pi pi-times cursor-pointer" (click)="filterDialog=false"></i>
            </div>
        </div>
        <div class="flex flex-col h-full justify-between">
            <div class="p-4 gap-y-4 flex flex-col overflow-y-auto">
                <!-- Source Multi-select -->
                <div>
                    <div class="text-sm mb-2">{{ 'Source' | textCase }}</div>
                    <app-multi-select [options]="sourceOptions" [(value)]="selectedSources" optionLabel="name"
                        optionValue="value" [config]="{placeholder: 'Select source', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>

                <!-- Created By Multi-select -->
                <div>
                    <div class="text-sm mb-2">{{ 'Created by' | textCase }}</div>
                    <app-multi-select [options]="userOptions" [(value)]="selectedCreators" optionLabel="label"
                        optionValue="value" [config]="{placeholder: 'Select creators', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>

                <!-- Clause Bundle Multi-select -->
                <div>
                    <div class="text-sm mb-2">{{ 'Clause bundle' | textCase }}</div>
                    <app-multi-select [options]="clauseBundleOptions" [(value)]="selectedClauseBundles"
                        [config]="{placeholder: 'Select clause bundles', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>

                <!-- Created Date Range -->
                <div>
                    <div class="text-sm mb-2">{{ 'Created date' | textCase }}</div>
                    <app-datepicker [(value)]="selectedDateRange" (onChange)="onDateRangeChange()" [config]="{
                        selectionMode: 'range',
                        placeholder: 'Select date range',
                        styleClass: 'w-full',
                        showButtonBar: false,
                        showIcon: true,
                        appendTo: 'body',
                    }">
                    </app-datepicker>

                    <!-- Date Range Chips -->
                    <div class="flex items-center gap-2 mt-2">
                        <app-button label="Today" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('today') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('today')" />
                        <app-button label="Last 7 days" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('last7days') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('last7days')" />
                        <app-button label="Last 30 days" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('last30days') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('last30days')" />
                    </div>
                </div>

                <!-- Usage Count -->
                <div>
                    <div class="text-sm mb-2">{{ 'Usage count' | textCase }}</div>
                    <div class="flex items-center gap-2">
                        <div class="flex-1">
                            <input type="number" [(ngModel)]="minUsageCount" [min]="0" placeholder="Min"
                                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm text-gray-700 outline-none focus:border-orange-500" />
                        </div>
                        <div class="flex-1">
                            <input type="number" [(ngModel)]="maxUsageCount" [min]="minUsageCount || 0"
                                placeholder="Max"
                                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm text-gray-700 outline-none focus:border-orange-500" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer Actions -->
            <div class="p-4 flex gap-2 border-t border-gray-200">
                <div class="flex-1 min-w-0">
                    <app-button [label]="'Clear all' | textCase" variant="outlined" severity="contrast"
                        (clicked)="clearFilter()" [fullWidth]="true" />
                </div>
                <div class="flex-1 min-w-0">
                    <app-button [label]="'Apply filter' | textCase" variant="filled" severity="primary"
                        (clicked)="applyFilter()" [enableThrottle]="true" [fullWidth]="true" />
                </div>
            </div>
        </div>
    </ng-template>
</p-drawer>
}

<!-- Bulk Edit Clause Dialog -->
<app-dialog [(visible)]="showBulkEditDialog" (closed)="onBulkEditDialogHide()"
    class="w-[70vw] h-[70vh] flex bulk-edit-dialog-content clause-library-dialog">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2 pl-4">
            <span class="dialog-title">{{ 'Edit clauses' | textCase }}</span>
            <span class="text-sm text-gray-600">
                ({{ savedClauses.size }}/{{ totalEditingCount }})
            </span>
        </div>
    </ng-template>

    <ng-template #bodyTemplate>
        <div class="h-full flex flex-row justify-between gap-4">
            <div class="h-full w-[40%]">
                <div class="clause-cards-container mb-4">

                    <div *ngFor="let clause of editingClauses; let i = index"
                        class="clause-card mb-3 p-3 border rounded-base cursor-pointer transition-all bg-white border-gray-200 shadow-sm"
                        [ngClass]="{'selected-card': currentEditIndex === i}" (click)="selectClauseForEdit(i)">
                        <div class="overflow-auto">
                            <div class="font-semibold text-sm mb-2 truncate">
                                {{ clause.name }}
                            </div>
                            <div class="text-xs text-gray-600 truncate">
                                {{ clause.text }}
                            </div>
                        </div>
                        <div>
                            @if(savedClauses.has(i)) {
                            <div class="flex flex-col gap-1 items-center">
                                <i class="pi pi-check-circle text-success"></i>
                                <span class="text-xs text-success">Done</span>
                            </div>
                            } @else if(currentEditIndex === i) {
                            <i class="pi pi-chevron-right font-bold"></i>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Panel - Edit Form -->
            <div class="h-full w-[60%]">
                <div *ngIf="editingClauses[currentEditIndex]"
                    class="flex flex-col border-2 border-gray-100 rounded-base p-4 h-full">
                    <!-- Clause name -->
                    <div class="field">
                        <label class="flex text-sm font-medium mb-2">{{ 'Clause name' | textCase }}</label>
                        <textarea [(ngModel)]="editingClauses[currentEditIndex].name"
                            (ngModelChange)="saveClauseInBulkEdit(currentEditIndex)"
                            class="w-full border border-gray-200 px-2 py-3 rounded-xl text-sm outline-none resize-none"
                            rows="1" placeholder="Enter clause name..."></textarea>
                    </div>
                    <!-- Clause text -->
                    <div class="field flex flex-col flex-1 min-h-0">
                        <div class="flex items-center justify-between mb-2">
                            <div class="flex items-baseline gap-1">
                                <p class="text-sm">{{ 'Clause text' | textCase }}</p>
                                @if (bulkEditClauseTextExpanded) {
                                <app-button [icon]="'minimize-2'" variant="ghost" severity="contrast"
                                    [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                                    (clicked)="toggleBulkEditClauseTextExpanded()" />
                                } @else {
                                <app-button [icon]="'maximize-2'" variant="ghost" severity="contrast"
                                    [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                                    (clicked)="toggleBulkEditClauseTextExpanded()" />
                                }
                            </div>
                            <div class="flex items-center gap-2">
                                <app-button [icon]="CLAUSE_LIBRARY_ICONS.GENERATE_CLAUSE_TEXT"
                                    [iconSource]="ICON_SOURCE.SVG" [size]="'default'" variant="outlined"
                                    severity="contrast" [pTooltip]="'Generate clause text' | textCase"
                                    tooltipPosition="top" (clicked)="generateClauseTextForBulkEdit()"
                                    [loading]="bulkEditGenerateLoading" />
                                <app-button [icon]="CLAUSE_LIBRARY_ICONS.REPHRASE_CLAUSE_TEXT"
                                    [iconSource]="ICON_SOURCE.SVG" [size]="'default'" variant="outlined"
                                    severity="contrast" [pTooltip]="'Rephrase clause text' | textCase"
                                    tooltipPosition="top" (clicked)="rephraseClauseForBulkEdit()"
                                    [disabled]="!editingClauses[currentEditIndex].text.trim()"
                                    [loading]="bulkEditRephraseLoading" />
                            </div>
                        </div>
                        <div class="relative rounded-lg overflow-hidden"
                            [ngClass]="bulkEditClauseTextExpanded ? 'flex-1 min-h-0' : 'flex-shrink-0'"
                            [style.height]="bulkEditClauseTextExpanded ? null : '7rem'">
                            @if (bulkEditGenerateLoading || bulkEditRephraseLoading) {
                            <div
                                class="absolute inset-0 flex items-start justify-start gap-2 p-3 bg-white/80 z-10 rounded-lg">
                                <app-blob-loader [width]="'1.5rem'" [height]="'1.5rem'"></app-blob-loader>
                                <div class="text-sm italic theme-text">Constructing<span>{{ dots$ | async }}</span>
                                </div>
                            </div>
                            }
                            <textarea [(ngModel)]="editingClauses[currentEditIndex].text"
                                (ngModelChange)="saveClauseInBulkEdit(currentEditIndex)"
                                placeholder="Enter clause text..."
                                class="w-full h-full p-3 text-sm outline-none resize-none overflow-y-auto placeholder:text-gray-400 focus:border-orange-500 border-0 box-border"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="flex items-center gap-2">
                <app-button label="Prev" variant="outlined" (clicked)="navigateBulkEditPrevious()"
                    [disabled]="isBulkEditPreviousDisabled" />
                <app-button label="Next" variant="outlined" (clicked)="navigateBulkEditNext()"
                    [disabled]="isBulkEditNextDisabled" />
            </div>
            <div class="flex gap-2">
                <app-button label="Save ({{ savedClauses.size }}/{{ totalEditingCount }})" variant="filled"
                    (clicked)="onSaveBulkEdit()" [disabled]="isBulkEditSaveDisabled" [loading]="isBulkEditSaving"
                    severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- Delete Confirm Dialog -->
@if(showDeleteConfirmDialog) {
<app-delete-confirmation [(visible)]="showDeleteConfirmDialog"
    [headerText]="'You are about to delete ' + itemsToDeleteCount + ' clause' + (itemsToDeleteCount > 1 ? 's' : '')"
    bodyText="This action cannot be undone and will delete all selected clauses permanently. Are you sure you want to delete them?"
    confirmButtonText="Yes, delete" (onConfirm)="confirmDelete()" (onCancel)="cancelDelete()">
</app-delete-confirmation>
}

<!-- File Selection Dialog for Upload Contract -->
<app-file-selection [(visible)]="fileSelectionVisible" [config]="fileSelectionConfig()" [fetch]="fileSelectionFetch"
    [dropdownOptions]="clauseBundleDropdownOptions()" [bodyHeader]="clauseBundleHeaderTemplate"
    (onSubmit)="onFileSelectionSubmit($event)" (onCancel)="onFileSelectionCancel()">
</app-file-selection>

<!-- Clause Bundle Header Template (Upload contract: multi-select) -->
<ng-template #clauseBundleHeaderTemplate>
    <div class="flex flex-col sm:flex-row gap-2 items-stretch sm:items-end">
        <div class="flex-1">
            <p class="text-sm mb-2">{{ 'Clause bundle' | textCase }}</p>
            <app-multi-select [options]="clauseBundleOptions" [(value)]="uploadContractSelectedBundleIds"
                [config]="{ placeholder: 'Select clause bundles', styleClass: 'w-full' }">
            </app-multi-select>
        </div>
        <app-button label="Add" variant="outlined" severity="contrast" (clicked)="addClauseNewBundle()"
            class="h-[2.5rem]" />
    </div>
</ng-template>

<!-- Clause Extraction / Analyzing Document Dialog -->
<app-dialog [(visible)]="showClauseExtractionDialog" (closed)="onCloseClauseExtractionDialog()"
    class="max-w-[32rem] clause-library-dialog clause-extraction-dialog">
    <ng-template #headerTemplate>
        <div class="flex items-center justify-between w-full">
            <h2 class="text-lg font-semibold text-gray-900">{{ 'Analyzing document' | textCase }}</h2>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col items-center gap-6 py-4">
            <!-- Animation Container -->
            <div class="relative flex items-center justify-center w-full">
                @if (clauseExtractionAnimationData) {
                <div class="relative">
                    <app-lottie-animation [animationData]="clauseExtractionAnimationData" [loop]="true"
                        [autoplay]="true" width="300px" height="300px" containerClass="clause-extraction-lottie">
                    </app-lottie-animation>
                </div>
                }
            </div>

            <!-- Status Message -->
            <div class="flex flex-col gap-2 text-center">
                <p class="text-sm text-gray-900 leading-relaxed">
                    Our AI is processing your document. We'll notify you once the clauses are ready.
                </p>
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- History sidebar (uploaded files / clause extraction audit) -->
@if(openHistorySidebar) {
<p-drawer [(visible)]="openHistorySidebar" position="right" [style]="{width: '30rem'}" closable="false">
    <ng-template pTemplate="headless">
        <div class="flex flex-col h-full min-h-0">
            <div class="flex items-center w-full justify-between border-b p-4 shrink-0">
                <div class="flex items-center justify-start">
                    <span class="!text-xl font-bold">{{ 'Uploaded files audit' | textCase }}</span>
                </div>
                <div class="flex items-center justify-end">
                    <i class="pi pi-times cursor-pointer" (click)="openHistorySidebar=false"></i>
                </div>
            </div>
            <div class="flex flex-col gap-3 p-4 flex-1 min-h-0 overflow-y-auto">
                @if(uploadedFilesAudit.length === 0) {
                <div class="flex flex-1 items-center justify-center text-gray-500">
                    <span class="text-md">No uploaded files yet</span>
                </div>
                } @else {
                @for(file of uploadedFilesAudit; track file._id) {
                <div class="flex flex-col gap-2 border rounded-base p-2">
                     <app-credits-overview
                        variant="exhaustioncard"
                        feature="CLAUSE_EXTRACTION"
                        mode="agent"
                        [featureId]="file._id"
                        [credits]="creditsState.credits()"
                        [externalResume]="true"
                        (resume)="onResumeClauseExtraction(file)" />
                    <div class="flex flex-row items-center justify-between gap-2">
                        <div class="flex items-center gap-2">
                            <span class="text-sm font-semibold">{{file.attachment?.filename}}</span>
                            <i class="pi pi-eye text-gray-400 cursor-pointer" (click)="openHistoryFilePreview(file)"></i>
                        </div>
                        <div class="flex items-center gap-2 px-2 py-1 rounded-base h-fit" [ngClass]="{
                            'text-success bg-green-50 border-1 border-green-600': file.status === CLAUSE_METADATA_STATUS.COMPLETED,
                            'text-arena-blue-600 bg-blue-50 border-1 border-blue-600': file.status === CLAUSE_METADATA_STATUS.IN_PROGRESS,
                            'text-danger bg-red-50 border-1 border-red-600': file.status === CLAUSE_METADATA_STATUS.FAILED,
                            'text-gray-600 bg-gray-50 border-1 border-gray-600': file.status === CLAUSE_METADATA_STATUS.PENDING
                        }">
                            <span class="text-xs">{{file.status}}</span>
                        </div>
                    </div>
                </div>
                }
                }
            </div>
        </div>
    </ng-template>
</p-drawer>
}

<app-dialog [(visible)]="showHistoryFilePreview" (closed)="closeHistoryFilePreview()"
    class="w-[90vw] max-w-[56rem] h-full history-file-preview-dialog">
    <ng-template #headerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="text-sm sm:text-base font-bold truncate">{{ selectedHistoryFileAttachment?.filename || 'File
                preview' }}</div>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="h-full w-full min-h-[24rem]">
            @if(isLoadingHistoryPreview) {
            <div class="flex items-center justify-center h-full min-h-[24rem]">
                <i class="pi pi-spinner pi-spin text-3xl text-blue-600"></i>
            </div>
            } @else if(selectedHistoryFileAttachment && selectedHistoryDocumentId) {
            <app-multi-format-preview [documentId]="selectedHistoryDocumentId" [file]="selectedHistoryFileAttachment">
            </app-multi-format-preview>
            }
        </div>
    </ng-template>
</app-dialog>

<p-confirmDialog #cd>
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-col gap-2 align-items-center p-4 surface-overlay border-round w-[30rem]">
            <div class="flex flex-row gap-2 items-start">
                <app-icon [type]="'triangle-alert'" [source]="'lucide'" [size]="'xl'" variant="primary" />
                <div class="flex flex-col gap-2">
                    <span class="font-bold text-md mt-[-2px]">{{ message.header }}</span>
                    <p class="mb-0 text-sm text-gray-600" [innerHTML]="message.message | sanitizeHtml"></p>
                </div>
            </div>
            <div class="flex justify-end items-end float-left gap-2 mt-4">
                <app-button [label]="message.acceptLabel ?? 'Save and close'" variant="outlined" severity="contrast"
                    (clicked)="handleConfirmAccept(message)" />
                <app-button [label]="message.rejectLabel ?? 'Keep editing'" variant="filled" severity="primary"
                    (clicked)="handleConfirmReject(message)" />
            </div>
        </div>
    </ng-template>
</p-confirmDialog>
